const { cELM, Wrap4ArrowMulti } = require("../../utils");
const Chat = require("../../chat");

class HeightInput {
  constructor(data) {
    this._data = data;
    this.element = cELM("div", "option-block");
    this.__elements = null;
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const inputContainer = cELM("div", "inputs-wrapper");
    const feetEl = cELM("input", "number-input");
    const inchEl = cELM("input", "number-input");

    const _self = this;

    feetEl.type = "number";
    inchEl.pattern = "[0-9]*";
    feetEl.placeholder = "Feet";
    inchEl.type = "number";
    feetEl.pattern = "[0-9]*";
    inchEl.placeholder = "Inches";

    const buttonEl = cELM("div", "continue-button continue-button-active", "Continue");

    const feetWrp = Wrap4ArrowMulti(feetEl, true);
    const inchWrp = Wrap4ArrowMulti(inchEl);

    buttonEl.onclick = function(evt) {
      if (_self.validate()) {
        const op = feetEl.value + "ft. - " + inchEl.value + " in.";
        
        Chat.default.send({
            text: op,
            id: _self._data.id
          },
          null, 
          _self.element
        );
      }
    };


    const onKeyUp = (el, nextEl, limit, type) =>
      function(evt) {
        var kc = evt.which || evt.keyCode;
        if (!kc || kc == 229) {
          let ss = evt.target.selectionStart - 1;
          let ssv = ss || 0;
          let char = evt.target.value.substr(ssv, 1);
          kc = char.charCodeAt(0);
        }

        if (el.value.length < 1 && type === "feet") {
          if (kc > 0) {
            // bigger than or equal to 2
            nextEl.focus();
          }
        } 

        if (el.value.length > limit) {
          el.value = el.value.slice(0, limit);
        }

        if (el.value.length >= limit) {
          if (nextEl) {
            nextEl.focus();
          }

          if (type === "inch") {
            el.blur();
            buttonEl.click();
          }
        }

        if (
          type === "inch" &&
          el.value.length === 1 &&
          Number(el.value) > 1 &&
          Number(el.value) <= 12
        ) {
          el.blur();
          buttonEl.click();
        }

        if (_self.validate(true)) {
          feetWrp.classList.remove("arrow-active");
          inchWrp.classList.remove("arrow-active");
          buttonEl.classList.add("continue-button-active");
          buttonEl.classList.add("arrow-active");

          if (evt.key === "Enter") {
            el.blur();
            buttonEl.click();
          }
        } else {
          buttonEl.classList.remove("continue-button-active");
          buttonEl.classList.remove("arrow-active");
        }
      };


    const onKeyDown = function(evt) {
      // disable inputing "e"
      return evt.keyCode !== 69;
    };


    feetEl.onkeyup = onKeyUp(feetEl, inchEl, 1, "feet");
    inchEl.onkeyup = onKeyUp(inchEl, buttonEl, 2, "inch");

    feetEl.onkeydown = onKeyDown;
    inchEl.onkeydown = onKeyDown;
   
    inputContainer.addELM(feetWrp);
    inputContainer.addELM(cELM("div", "slash", "/"));
    inputContainer.addELM(inchWrp);
    this.element.addELM(inputContainer);
    this.element.addELM(buttonEl);
    this.__elements = { feetEl, inchEl };
    return this.element;
  }

  validate() {
    let valid = true;
    const { feetEl, inchEl } = this.__elements;
    feetEl.classList.remove("invalid");
    inchEl.classList.remove("invalid");

    if (!feetEl.value) {
      feetEl.classList.add("invalid");
      valid = false;
    }
    if (!inchEl.value) {
      inchEl.classList.add("invalid");
      valid = false;
    }

    return valid;
  }

  reset() {
    if (!this.__elements) return;
    this.__elements.feetEl.value = "";
    this.__elements.inchEl.value = "";
    this.__elements.feetEl.focus();
  }

  focus() {
    //this.__elements.feetEl.focus();
  }
}

module.exports = HeightInput;
